import { ClientType } from '../apollo'
import { ApolloQueryResult, types } from '../types'

import { q_findManyCommerceOrderReview } from './commerce-gql'
import { createOneCommerceOrderReview, findUniqueCommerceOrderReview } from '@dinosband/bv-main-schema/dist/client-gql'

interface Mutations {
  createOneCommerceOrderReview: types.CommerceOrderReview
  updateOneCommerceOrderReview: types.CommerceOrderReview
}

type MutationResult = ApolloQueryResult<Mutations>

export async function createCommerceOrderReview (client: ClientType, data: types.CommerceOrderReviewCreateInput): Promise<types.CommerceOrderReview> {
  const result = await client.mutate({
    mutation: createOneCommerceOrderReview,
    variables: {
      data,
    } as types.MutationCreateOneCommerceOrderReviewArgs,
  }) as MutationResult
  return result.data.createOneCommerceOrderReview
}

export async function readCommerceOrderReviews (client: ClientType, where: types.CommerceOrderReviewWhereInput, orderBy?: types.CommerceOrderReviewOrderByWithRelationInput[], cursor?: number, take?: number): Promise<types.CommerceOrderReview[] | undefined> {
  const result = await client.query({
    query: q_findManyCommerceOrderReview,
    variables: {
      where,
      orderBy,
      cursor: cursor ? { id: cursor } : undefined,
      skip: cursor ? 1 : undefined,
      take,
    } as types.QueryFindManyCommerceOrderReviewArgs,
  })
  return result.data.findManyCommerceOrderReview
}

export async function readCommerceOrderReview (client: ClientType, where: types.CommerceOrderReviewWhereUniqueInput): Promise<types.CommerceOrderReview | undefined> {
  const result = await client.query({
    query: findUniqueCommerceOrderReview,
    variables: {
      where,
    } as types.QueryFindManyCommerceOrderReviewArgs,
  })
  return result.data.findUniqueCommerceOrderReview
}
